import { AbstractControl, ValidatorFn } from '@angular/forms';

export function validateCurrentTimeThanSmall(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    return new Date(control.value).getTime() < Date.now() ? {'currentTimeThanSmall': {value: control.value}} : null;
  };
}

export function validateCurrentTime30PartAfterThanSmall(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    return new Date(control.value).getTime() < Date.now() + (30 * 60 * 1000) ? {'currentTime30PartAfterThanSmall': {value: control.value}} : null;
  };
}

export function validateTooManyValues(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    return isNaN(new Date(control.value).getFullYear()) ? {'tooManyValues': {value: control.value}} : null;
  }
}
